import React, { useState } from 'react';

interface Tab {
    id: string;
    title: string;
}

interface TeamTabsV2Props {
    onTabChange: (tabId: string) => void;
    initialTab?: string;
}

const tabs: Tab[] = [
    { id: 'matches', title: 'Kampe' },
    { id: 'veto', title: 'Vetos' },
    { id: 'roles', title: 'Roller og Positioner' },
    { id: 'stats', title: 'Statistik' }
];

const TeamTabsV2: React.FC<TeamTabsV2Props> = ({ onTabChange, initialTab = "matches" }) => {
    const [activeTab, setActiveTab] = useState<string>(initialTab);

    const handleTabClick = (tabId: string) => {
        setActiveTab(tabId);
        onTabChange(tabId);
    };

    return (
        <ul className="nav nav-pills mb-0" role="tablist" style={{ gap: 4 }}>
            {tabs.map((tab) => (
                <li key={tab.id} className="nav-item" role="presentation">
                    <button
                        className={`nav-link ${tab.id === activeTab ? 'active' : ''}`}
                        type="button"
                        role="tab"
                        aria-selected={tab.id === activeTab}
                        onClick={() => handleTabClick(tab.id)}
                        style={{
                            background: tab.id === activeTab ? '#ff6600' : 'rgba(255, 255, 255, 0.05)',
                            color: tab.id === activeTab ? '#ffffff' : 'rgba(255, 255, 255, 0.8)',
                            border: tab.id === activeTab ? '1px solid #ff6600' : '1px solid rgba(255, 102, 0, 0.2)',
                            borderRadius: '8px',
                            padding: '8px 20px',
                            fontWeight: tab.id === activeTab ? '600' : '500',
                            transition: 'background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            if (tab.id !== activeTab) {
                                e.currentTarget.style.background = 'rgba(255, 102, 0, 0.1)';
                                e.currentTarget.style.borderColor = 'rgba(255, 102, 0, 0.3)';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (tab.id !== activeTab) {
                                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                                e.currentTarget.style.borderColor = 'rgba(255, 102, 0, 0.2)';
                            }
                        }}
                    >
                        {tab.title}
                    </button>
                </li>
            ))}
        </ul>
    );
};

export default TeamTabsV2;
